import React from 'react';
import { PieChart } from 'lucide-react';
import { formatShareCount } from '../../utils/ipoSubscription';
import { formatCrore } from '../../utils/issueSubscription';

const BAR_TONE = { qib: 'bg-indigo-500', nii: 'bg-amber-500', retail: 'bg-[#008080]' };

// allocation: utils/issueSubscription.js buildQuotaAllocation
export const QuotaAllocation = ({ allocation, board, anchorBidLabel }) => (
  <section aria-labelledby="quota-heading" className="bg-white rounded-2xl border border-slate-200/90 shadow-sm p-4 sm:p-5 flex flex-col">
    <div className="flex items-center justify-between gap-2">
      <h2 id="quota-heading" className="flex items-center gap-2 text-sm font-extrabold text-slate-900">
        <PieChart className="w-4 h-4 text-[#008080]" aria-hidden="true" />
        Issue Quota Allocation
      </h2>
      <span className="text-[10px] font-extrabold uppercase tracking-wider text-slate-400">Public book</span>
    </div>
    <p className="mt-1 text-[11px] text-slate-500">Shares offered to each investor category for bidding, valued at the upper price band.</p>

    {allocation.length ? (
      <ul className="mt-3 space-y-3">
        {allocation.map((entry) => (
          <li key={entry.key}>
            <div className="flex items-baseline justify-between gap-2 text-xs">
              <span className="font-bold text-slate-800">{entry.label}</span>
              <span className="font-extrabold text-slate-900 tabular-nums whitespace-nowrap">
                {entry.percent.toFixed(2)}%{entry.amountCr !== null && <span className="ml-1 font-semibold text-slate-400">({formatCrore(entry.amountCr)})</span>}
              </span>
            </div>
            <div className="mt-1 h-1.5 rounded-full bg-slate-100 overflow-hidden" aria-hidden="true">
              <div className={`h-full rounded-full ${BAR_TONE[entry.key] || 'bg-slate-400'}`} style={{ width: `${entry.percent}%` }} />
            </div>
            <p className="mt-0.5 text-[10px] text-slate-400">
              {formatShareCount(entry.offered)} shares
              {entry.children.length > 0 && ` · ${entry.children.map((child) => `${child.label.replace(/\s*\(.*\)/, '')} ${child.percent.toFixed(2)}%`).join(' · ')}`}
            </p>
          </li>
        ))}
      </ul>
    ) : (
      <p className="mt-3 rounded-xl border border-dashed border-slate-200 bg-slate-50 px-3 py-6 text-center text-xs text-slate-500">
        The category split is published with the bid book when bidding opens.
      </p>
    )}

    <p className="mt-auto pt-3 border-t border-slate-100 text-[10px] text-slate-400 leading-relaxed">
      SEBI norms for the net offer: QIB up to 50%, non-institutional at least 15%, {board === 'sme' ? 'individual investors' : 'retail'} at
      least 35%. Up to 60% of the QIB portion goes to anchors before the issue opens and is not part of this book.
      {anchorBidLabel && <span className="block mt-1 font-semibold text-slate-500">Anchor bidding: {anchorBidLabel}</span>}
    </p>
  </section>
);

export default QuotaAllocation;
